import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import classNames from 'classnames';
import Loading from '@/components/loading-spinner';
import styles from './AiLabPageShell.module.scss';

const BackButton = ({ to, onClick, children }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={
        onClick ||
        (() => {
          if (to) {
            navigate(to);
          }
        })
      }
      className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 transition"
      type="button"
    >
      <ChevronLeft size={16} />
      {children}
    </button>
  );
};

const AiLabPageShell = ({
  title,
  backTo = '/ailab',
  backText = '返回',
  onBack,
  template = 'center',
  className,
  contentClassName,
  loading,
  loadingTip,
  tip,
  bordered = false,
  children,
  ...props
}) => {
  const isFull = template === 'full';

  return (
    <div className={styles.shell}>
      <div className={styles.container}>
        <div className={styles.header}>
          <BackButton to={backTo} onClick={onBack}>
            {backText}
          </BackButton>
          <h1 className={styles.title}>{title}</h1>
        </div>

        <div
          className={classNames(styles.box, contentClassName, {
            [styles.bordered]: bordered,
          })}
        >
          <Loading
            loading={loading}
            tip={loadingTip}
            className={isFull ? styles.loadingFull : styles.loadingCenter}
          >
            <div
              className={classNames(
                isFull ? styles.contentFullInner : styles.contentCenterInner,
                className,
              )}
              {...props}
            >
              {children}
            </div>
          </Loading>
        </div>

        {tip ? <div className={styles.tip}>{tip}</div> : null}
      </div>
    </div>
  );
};

export default AiLabPageShell;
